export default __webpack_public_path__ + "static/media/sushi_token_logo.ee7fe123.webp";